import ActiveUsersChart from '@/components/Analytics/ActiveUsersChart';
// import GasConsumptionChart from '@/components/Analytics/GasConsumptionChart';
import RevenueChart from '@/components/Analytics/RevenueChart';
import TotalValueLockedChart from '@/components/Analytics/TotalValueLockedChart';
import TradingVolumeChart from '@/components/Analytics/TradingVolumeChart';
import TransactionsChart from '@/components/Analytics/TransactionsChart';
import { useAnalytics } from '@/contexts/AnalyticsContext';
import React from 'react';

const RwaSection: React.FC = () => {
  const { data, loading } = useAnalytics();

  return (
    <section>
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-text-black">RWA</h2>
      </div>

      {loading && (
        <div className="flex items-center justify-center h-64">
          <div className="text-text-main-body">Loading chart data...</div>
        </div>
      )}

      {!loading && data && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <TradingVolumeChart data={data.rwa.volume?.data} showTopMarkets={false} />
          <ActiveUsersChart data={data.rwa.users?.data} />
          <TransactionsChart data={data.rwa.transactions?.data} />
          <TotalValueLockedChart data={data.rwa.tvl?.data} />
          <RevenueChart data={data.rwa.revenue?.data} />
          {/* <GasConsumptionChart data={data.rwa.gasConsumption?.data} /> */}
        </div>
      )}
    </section>
  );
};

export default RwaSection;
